export const submitDate = (dateOfBirth: string) => {
  const [day, month, year] = dateOfBirth.split('/');

  if (!day || !month || !year) {
    return 'Invalid date';
  }

  return `${year}-${month}-${day}`;
};
